"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    MaxRoomsBannerMessage: ()=>MaxRoomsBannerMessage
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../../Text/index.cjs");
const external_A_index_cjs_namespaceObject = require("../../A/index.cjs");
const external_Button_index_cjs_namespaceObject = require("../../Button/index.cjs");
const external_constants_cjs_namespaceObject = require("../constants.cjs");
function MaxRoomsBannerMessage({ maxRoomsMessage, maxRoomsUrl, fireMaxRoomsOnClick, maxRooms = external_constants_cjs_namespaceObject.DEFAULT_MAX_TRAVELERS }) {
    const defaultMaxRoomsMessage = `You may only book up to ${maxRooms} rooms.`;
    function onMaxRoomsBannerClick() {
        if (fireMaxRoomsOnClick) fireMaxRoomsOnClick();
    }
    const MaxRoomsNode = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            maxRooms + 1,
            " Rooms or More ",
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                iconName: "arrow_forward"
            })
        ]
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Text_index_cjs_namespaceObject.P, {
                children: [
                    " ",
                    maxRoomsMessage ?? defaultMaxRoomsMessage
                ]
            }),
            maxRoomsUrl && !fireMaxRoomsOnClick ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_A_index_cjs_namespaceObject.A, {
                type: "tertiary",
                className: "justify-start",
                href: maxRoomsUrl,
                target: "_blank",
                children: MaxRoomsNode
            }) : null,
            fireMaxRoomsOnClick ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
                type: "tertiary",
                className: "flex items-center",
                onClick: onMaxRoomsBannerClick,
                children: MaxRoomsNode
            }) : null
        ]
    });
}
exports.MaxRoomsBannerMessage = __webpack_exports__.MaxRoomsBannerMessage;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "MaxRoomsBannerMessage"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
